<div *ngIf="isPageReady" class="flex flex-col h-full w-full">


  <div class="flex pb-2 gap-4">


    <div class="w-1/3">
      <prox-field label="Note Dated">
        <p-datepicker [showTime]="true" [disabled]="true" [ngModel]="proximityUserNote.noteTs"
          [bzModel]="proximityUserNote" name="noteTs"></p-datepicker>
      </prox-field>
    </div>
  </div>

  <div class="grow h-full w-full mb-8">
    <label>Note </label>

    <textarea class="w-full h-full" [disabled]="!isEditable" pTextarea [(ngModel)]="proximityUserNote.note"
      [bzModel]="proximityUserNote" name="note"></textarea>


  </div>

  <div class="flex">
    <div class="mr-2">
      <button (click)="onOk()" pButton type="button" label="Ok" icon="pi pi-check" class="p-button-raised"></button>
    </div>
    <div class="mr-2">
      <button (click)="onCancel()" pButton type="button" label="Cancel" icon="pi pi-times"
        class="p-button-raised"></button>
    </div>
  </div>
</div>